module.exports = "/static/assets/5b91a86ddfdef5d57cd5b190eab2f37e.gif";